export const NAV_LINK_LIST = [
  { title: "Team", path: "/#team" },
  { title: "Portfolio", path: "/portfolio" },
  { title: "Node", path: "/node" },
  { title: "Insights", path: "/insights" },
  { title: "About", path: "/about" },
];
